import $i18n from '@/locales/i18n';
const FUSION_UI_VIEW_PREFIX = 'fd-layout-view';
export const AddSection = ({ onClick, alwaysShow = false, }) => {
    return (<div className={`${FUSION_UI_VIEW_PREFIX}-section-add`}>
      <div className={`${FUSION_UI_VIEW_PREFIX}-section-add-wrapper ${alwaysShow ? 'show' : ''}`}>
        <div className={`${FUSION_UI_VIEW_PREFIX}-section-add-icon`}>
          <div onClick={onClick}>
            {$i18n.get({ id: 'AddANewLayoutContainer', dm: '添加新的布局容器' })}
          </div>
        </div>
      </div>
    </div>);
};
